var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{class:{white: _vm.white},attrs:{"icon":['fad', 'spinner'],"size":_vm.size,"spin":""}})}
var staticRenderFns = []

export { render, staticRenderFns }